export const DEFAULT_VALUES = {
    BORDER_COLOR: '#CB1010',
    BACKGROUND_COLOR: '#CB1010',
    DEFAULT_ICON_IMAGE: 'https://media.appcharge.com/defaults/default-store-logo.svg',
    DEFAULT_ICON_ALT_TEXT: 'Default Appcharge icon'
} as const;

export const UPLOAD_CONFIG = {
    BUTTON_IMAGE_DESCRIPTION: 'For optimized display, make sure your image is at least 2:1 Ratio | PNG, JPEG | Max 40px height',
    ICON_IMAGE_TOOLTIP: 'Image with 1:1 ratio with max 192px width',
    BUTTON_TEXT: 'Upload'
} as const;

export const FORM_LABELS = {
    ACTIVATE_FEATURE: 'Activate this feature in your portal',
    BORDER_AND_TEXT_COLOR: 'Border and Text Color',
    BACKGROUND_COLOR: 'Background Color',
    BUTTON_IMAGE: 'Button Image',
    ICON_IMAGE: 'Icon Image',
    PORTAL_TITLE: 'Portal Title'
} as const;